import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function SiteLayout({ children }) {
  return (
    <div className="min-h-screen relative grain" data-testid="site-layout">
      <Header />
      <main className="pt-24 md:pt-28" data-testid="site-main">{children}</main>
      <Footer />
    </div>
  );
}
